<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()">Nuevo Usuario</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 30 : 5"
        :dark="dark"
        pagination
        :tableFilter="{label: 'Buscar: ', placeholder: ' '}"
        :itemsPerPageSelect="{label: 'Usuarios por página: ', values: [10,20,30,50,100]}"
      >
        <template #name="{item}">
          <td class="text-left" style="font-size: 12px;">{{ item.name }}</td>
        </template>
        <template #email="{item}">
          <td class="text-center" style="font-size: 12px;">{{ item.email }}</td>
        </template>
        <template #role="{item}">
          <td class="text-center" style="font-size: 12px;">{{ item.role }}</td>
        </template>
        <template #actions="{item}">
          <td class="table_actions" style="font-size: 12px;">
            <CButton color="warning" size="sm" @click="updateModal(item)">
              <CIcon name="cil-pencil"/>
            </CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)">
              <CIcon name="cil-trash"/>
            </CButton>
          </td>
        </template>

      </CDataTable>
    </CCardBody>
    <UserModal ref="userModal" @store="storeProcess" @update="updateProcess"></UserModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import UserModal from './UserModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import ws from '../../services/users';
import store from '../../store'

export default {
  name: 'UsersTable',
  components: { UserModal, DeleteModal },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return [
          { key: 'name', label: 'Nombre', _style: "font-size: 12px" },
          { key: 'email', label: 'Correo Electrónico', _style: "font-size: 12px" },
          { key: 'role', label: 'Rol de Usuario', _style: "font-size: 12px" },
          { key: 'actions', label: 'Acciones', class: 'actions', _style: "font-size: 12px" },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
    }
  },
  methods: {
    storeModal () {
      this.$refs.userModal.storeModal();
    },
    updateModal (item) {
      this.$refs.userModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Usuario", item.id, item.name);
    },
    async storeProcess(data) {
      this.loading();
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.loaded();
      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      this.loading();
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.loaded();
      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      this.loading();
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }
      this.loaded();
      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
